import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { S3PortfoliosEdit } from "./edit";
import { S3PortfoliosNew } from "./new";
import { S3PortfoliosTable } from "./table";
export default function S3Portfolios() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Portefeuilles");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<S3PortfoliosEdit />} />
      <Route index element={<S3PortfoliosTable />} />
      <Route path="/new" element={<S3PortfoliosNew />} />
    </Routes>
  );
}
